// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import translate from "@insite/client-framework/Translate";
import useBuyingList from "@store/Framework/Common/Hooks/useBuyingList/useBuyingList";
import { CustomerLocation } from "@store/Framework/Store/Bunzl/Pages/Reporting/LoadLocations";
import { locationsSelector } from "@store/Framework/Store/Bunzl/Pages/Reporting/ReportOrderFrequency/ReportOrderFrequencySelectors";
import CheckboxModalPicker from "@store/Library/Components/Reporting/ModalPicker/CheckboxModalPicker";
import ModalPicker from "@store/Library/Components/Reporting/ModalPicker/ModalPicker";
import useCheckboxPicker from "@store/Library/Components/Reporting/ModalPicker/useCheckboxPicker";
import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

interface ShipToSelectorProps {
    buyingListId: string;
}

const ShipToSelector: React.FC<ShipToSelectorProps> = ({ buyingListId }) => {
    const { billToId } = useAppSelector(state => state.context.session);
    const hasRun = useRef(false);
    const { activeBuyingList, updateBuyingLists, buyingLists, updateAssignedCustomers } = useBuyingList();
    const { selectedItems, toggleItem, toggleAllItems, setSelectedItems } = useCheckboxPicker();
    const locationData = useSelector(locationsSelector);

    const location = locationData?.find(location => location.id === billToId);

    const getDisplayName = (customer: CustomerLocation) => {
        return `${customer.displayName} (${customer.customerSequence})`;
    };

    useEffect(() => {
        const selectedCustomerIds = selectedItems.map(selectedItem => {
            const customer = locationData
                ?.find(location => location.id === billToId)
                ?.customers?.filter(customer => getDisplayName(customer) === selectedItem)?.[0];
            return customer?.id as string;
        });
        if (selectedCustomerIds.length !== activeBuyingList?.customers?.length && hasRun.current) {
            updateAssignedCustomers(buyingListId, selectedCustomerIds);
        }
    }, [selectedItems.length]);
    if (!billToId || !locationData || !activeBuyingList) {
        return null;
    }
    if (!hasRun.current) {
        const activeNames = activeBuyingList.customers?.map(({ id }) => {
            const customer = location?.customers?.find(customer => customer.id === id);
            if (!customer) {
                return undefined;
            }
            return getDisplayName(customer);
        });
        // needed for typescript to know that there isn't any undefined values in the array
        const namesWithoutUndefined = activeNames?.filter((name): name is string => name !== undefined);
        setSelectedItems(namesWithoutUndefined);
        hasRun.current = true;
    }

    const data = location?.customers.map(getDisplayName) || [];
    const locationName = location?.name || "";

    return (
        <ModalPicker
            hideHeader={true}
            toggleItem={toggleItem}
            toggleAllItems={toggleAllItems}
            selectedItems={selectedItems}
            data={data}
            header={`${translate("Select Ship Tos from {0}", locationName)}`}
        />
    );
};

export default ShipToSelector;
